<script>
    import ClientLayout from '@/Layouts/Client';
    export default {
        layout: ClientLayout,
        props: ['sections'],

        data () {
            return {
                activeQuestion: null,
            }
        }
    }
</script>

<style>
    .clear > * {
        all:  revert;
    }
</style>

<template>
    <div>
        <div class="flex flex-col md:flex-row md:h-12 items-center mb-6 md:mb-2">
            <h2 class="text-md md:text-2xl text-red font-avertaBold">
                <span class="uppercase">Mina sidor Företag</span>
                / <span class="font-averta">Frågor och svar</span>
            </h2>
        </div>

        <div class="bg-white rounded-md shadow-sm p-6 space-y-4">
            <section v-for="(questions, section) in sections">
                <h1 style="margin-bottom: 10px; font-size: 19px;">{{ section }}</h1>
                <div v-for="(question, index) in questions" @click="activeQuestion == `${section}-${index}` ? activeQuestion = null : activeQuestion = `${section}-${index}`">
                    <div style="background: #f5f5f5; color: #444; padding: 10px 15px; font-size: 16px; cursor: pointer; user-select: none;">{{ question.title }}</div>

                    <div class="clear" v-if="activeQuestion == `${section}-${index}`" style="padding: 10px 15px; font-size: 14px; background: #fff;" v-html="question.content"></div>
                </div>
            </section>
        </div>
    </div>
</template>
